import { Typography } from '@mui/material'
import * as actions from '@returnmates/client-core/src/constants/actionTypes'
import { SnackBarStatuses } from '@returnmates/client-core/src/type'
import CloseSidebarIcon from '@returnmates/ui-core/src/components/imageComponents/flyoutSidebar/CloseIcon'
import ConsolidationsIcon from '@returnmates/ui-core/src/components/imageComponents/flyoutSidebar/ConsolidationsIcon'
import ContainersIcon from '@returnmates/ui-core/src/components/imageComponents/flyoutSidebar/ContainersIcon'
import CopyIcon from '@returnmates/ui-core/src/components/imageComponents/flyoutSidebar/CopyIcon'
import PackageDetailsIcon from '@returnmates/ui-core/src/components/imageComponents/flyoutSidebar/PackageDetails'
import PartnersIcon from '@returnmates/ui-core/src/components/imageComponents/flyoutSidebar/PartnersIcon'
import RouteIcon from '@returnmates/ui-core/src/components/imageComponents/flyoutSidebar/RouteIcon'
import StopDetailsIcon from '@returnmates/ui-core/src/components/imageComponents/flyoutSidebar/StopDetailsIcon'
import { memo, useCallback, useContext, useMemo } from 'react'
import { useDispatch } from 'react-redux'

import { FLYOUT_SIDEBAR_TYPES } from '../../constants/flyoutSidebar'
import { FlyoutSidebarContext } from '../../pages/Main'
import EditConsolidation from '../EditConsolidation'
import EditPackageForm from '../EditPackageForm'
import EditPickupForm from '../EditPickupForm'
import EditRouteForm from '../EditRouteForm'
import EditPartner from '../PartnerForm'
import useStyles from './styles'

function FlyoutSidebar() {
  const dispatch = useDispatch()
  const classes = useStyles()
  const { sidebarType, sidebarEntityId, handleCloseSidebar } = useContext(FlyoutSidebarContext)

  const sidebarData = useMemo(() => {
    switch (sidebarType) {
      case FLYOUT_SIDEBAR_TYPES.EDIT_PICKUP:
        return {
          component: <EditPickupForm id={sidebarEntityId} />,
          title: 'STOP DETAILS',
          headerIcon: <StopDetailsIcon />,
        }
      case FLYOUT_SIDEBAR_TYPES.EDIT_PACKAGE:
        return {
          component: <EditPackageForm id={sidebarEntityId} />,
          title: 'PACKAGE DETAILS',
          headerIcon: <PackageDetailsIcon />,
        }
      case FLYOUT_SIDEBAR_TYPES.EDIT_CONSOLIDATION:
        return {
          component: (
            <EditConsolidation
              type={FLYOUT_SIDEBAR_TYPES.EDIT_CONSOLIDATION}
              id={sidebarEntityId}
            />
          ),
          title: 'CONSOLIDATION DETAILS',
          headerIcon: <ConsolidationsIcon />,
        }
      case FLYOUT_SIDEBAR_TYPES.EDIT_CONTAINER:
        return {
          component: (
            <EditConsolidation type={FLYOUT_SIDEBAR_TYPES.EDIT_CONTAINER} id={sidebarEntityId} />
          ),
          title: 'CONTAINER DETAILS',
          headerIcon: <ContainersIcon />,
        }
      case FLYOUT_SIDEBAR_TYPES.EDIT_PARTNER:
        return {
          component: <EditPartner partnerCode={sidebarEntityId} />,
          title: 'PARTNER DETAILS',
          headerIcon: <PartnersIcon />,
        }
      case FLYOUT_SIDEBAR_TYPES.EDIT_ROUTE:
        return {
          component: <EditRouteForm id={sidebarEntityId} />,
          title: 'ROUTE DETAILS',
          headerIcon: <RouteIcon />,
        }
      default:
        return {}
    }
  }, [sidebarType, sidebarEntityId])

  const copyToClipboard = useCallback(() => {
    navigator.clipboard.writeText(sidebarEntityId || '')

    dispatch(
      actions.addSnackBar.request({
        type: SnackBarStatuses.SUCCESS,
        message: `ID was successfully copied to the clipboard`,
      }),
    )
  }, [dispatch, sidebarEntityId])

  return sidebarType && sidebarEntityId ? (
    <div>
      <div className={classes.header}>
        <div className={classes.titleContainer}>
          {sidebarData.headerIcon}
          <Typography className={classes.title}>{sidebarData.title}</Typography>
        </div>
        <div className={classes.entityIdContainer}>
          <Typography className={classes.entityId}>{sidebarEntityId}</Typography>
          <CopyIcon className={classes.copyIcon} onClick={copyToClipboard} />
        </div>
        <div className={classes.closeIcon} onClick={handleCloseSidebar}>
          <CloseSidebarIcon />
        </div>
      </div>
      <div className={classes.content}>{sidebarData.component}</div>
    </div>
  ) : null
}

export default memo(FlyoutSidebar)
